export const YOUNGEST_AGE_ON_PLATFORM = 13;

export const YOUNGEST_AGE_FOR_HEALTH_AND_PROMO = 16;

export const GENDER = Object.freeze({
  man: 'man',
  woman: 'woman',
  preferNotSay: 'prefer_not_say',
  nonBinary: 'nonbinary'
});

export const LOCALE = Object.freeze({
  csCZ: 'cs-CZ',
  daDK: 'da-DK',
  deDE: 'de-DE',
  enUS: 'en-US',
  esES: 'es-ES',
  es419: 'es-419',
  frFR: 'fr-FR',
  idID: 'id-ID',
  itIT: 'it-IT',
  jaJP: 'ja-JP',
  msMY: 'ms-MY',
  nbNO: 'nb-NO',
  nlNL: 'nl-NL',
  plPL: 'pl-PL',
  ptBR: 'pt-BR',
  ptPT: 'pt-PT',
  ruRU: 'ru-RU',
  svSE: 'sv-SE',
  thTH: 'th-TH',
  tlPH: 'tl-PH',
  trTR: 'tr-TR',
  viVN: 'vi-VN',
  zhCN: 'zh-CN',
  zhTW: 'zh-TW'
});

export default {
  YOUNGEST_AGE_ON_PLATFORM,
  YOUNGEST_AGE_FOR_HEALTH_AND_PROMO,
  GENDER,
  LOCALE
};
